<div *ngIf="projectData; else loading" class="container" style="margin-top:15px">
  <div style="position: relative;">
    <img class="img-style" [src]="getSantizeUrl()">
    <span class="vertical-center header">{{title}}</span>
  </div>

  <div>
    <p class="project-info">{{projectData.prTitle}}</p>
  </div>

  <div [ngClass]="(projectData.firmenNr == 1) ? 'red-style' : 'blue-style'">
    <mat-vertical-stepper linear="true" #stepper>
      <ng-template matStepperIcon="edit">
        <mat-icon>done</mat-icon>
      </ng-template>

      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup">
          <ng-template matStepLabel><b>{{q1}}</b></ng-template>
          <mat-radio-group formControlName="radioGroup1" required class="radio-group">
            <mat-radio-button *ngFor="let opt of q1Answers" [value]="opt.value">{{opt.text}}</mat-radio-button>
          </mat-radio-group>
          <div>
            <button class="btn btn-outline-dark" matStepperNext>{{nextMsg}}</button>
          </div>
        </form>
      </mat-step>

      <mat-step [stepControl]="secondFormGroup">
        <form [formGroup]="secondFormGroup">
          <ng-template matStepLabel><b>{{q2}}</b></ng-template>
          <mat-radio-group formControlName="radioGroup2" required class="radio-group">
            <mat-radio-button *ngFor="let opt of q2Answers" [value]="opt.value">{{opt.text}}</mat-radio-button>
          </mat-radio-group>
          <div>
            <button class="btn btn-outline-dark" matStepperPrevious>{{backMsg}}</button>
            <button class="btn btn-outline-dark" matStepperNext>{{nextMsg}}</button>
          </div>
        </form>
      </mat-step>

      <mat-step [stepControl]="thirdFormGroup">
        <form [formGroup]="thirdFormGroup">
          <ng-template matStepLabel><b>{{q3}}</b></ng-template>
          <mat-radio-group formControlName="radioGroup3" required class="radio-group">
            <mat-radio-button *ngFor="let opt of q3Answers" [value]="opt.value">{{opt.text}}</mat-radio-button>
          </mat-radio-group>
          <div>
            <button class="btn btn-outline-dark" matStepperPrevious>{{backMsg}}</button>
            <button class="btn btn-outline-dark" matStepperNext>{{nextMsg}}</button>
          </div>
        </form>
      </mat-step>

      <mat-step [stepControl]="fourthFormGroup">
        <form [formGroup]="fourthFormGroup">
          <ng-template matStepLabel><b>{{q4}}</b></ng-template>
          <mat-form-field style="width: 100%;">
            <textarea matInput formControlName="input" placeholder="{{placeholderMsg}}"
              style="height: 100px;"></textarea>
          </mat-form-field>

          <div>
            <button class="btn btn-outline-dark" matStepperPrevious>{{backMsg}}</button>
            <button class="btn btn-outline-dark" matStepperNext>{{nextMsg}}</button>
          </div>
        </form>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel><b>{{doneHeader}}</b></ng-template>
        <p>{{doneMessage}}</p>
        <div>
          <button class="btn btn-outline-dark" matStepperPrevious>{{backMsg}}</button>
          <button class="btn btn-outline-dark" [disabled]="sendBtnDisabled" (click)="onSubmitClicked()">
            <span style="display: flex; gap: 10px;">
              <mat-spinner *ngIf="sendBtnDisabled" diameter="20"></mat-spinner>
              {{sendMsg}}
            </span>
          </button>
        </div>
      </mat-step>
    </mat-vertical-stepper>
  </div>
</div>

<ng-template #loading>
  <div style="text-align: center; padding: 25%;">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
  <ng-template>